
import React, { useState } from 'react';
import NavBar from '@/components/NavBar';
import FilterBar from '@/components/FilterBar';
import TerraceList from '@/components/TerraceList';
import Footer from '@/components/Footer';
import { Sun } from 'lucide-react';
import { useTerraces } from '@/hooks/useTerraces';

const ListPage = () => {
  const [filters, setFilters] = useState({
    openNow: true,
    hasFood: false,
    petFriendly: false,
    servesAlcohol: false
  });

  const { terraces, loading } = useTerraces(filters);

  return (
    <div className="flex flex-col min-h-screen bg-warm-cream">
      <NavBar />
      
      <main className="flex-1">
        <div className="container px-3 sm:px-4 md:px-6 py-4 sm:py-6 space-y-4 sm:space-y-6">
          <div className="flex flex-col items-center text-center space-y-2 sm:space-y-3">
            <div className="flex items-center space-x-2">
              <Sun className="h-6 w-6 sm:h-8 sm:w-8 text-peach-orange" />
              <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-sunset-dark">All Terraces</h1>
            </div>
            <p className="text-sm sm:text-base text-sunset-medium max-w-[90%] sm:max-w-[600px] leading-relaxed">
              Browse and filter all terrace options in Stockholm.
            </p>
          </div>
          
          <FilterBar filters={filters} setFilters={setFilters} />
          
          <div className="py-2 sm:py-4">
            <TerraceList terraces={terraces} loading={loading} />
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ListPage;
